export default __webpack_public_path__ + "static/media/Figtree-Light.7ffa2a67.ttf";